import { render, staticRenderFns } from "./layers-design-list.vue?vue&type=template&id=f419b048"
import script from "./layers-design-list.vue?vue&type=script&lang=js"
export * from "./layers-design-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports